import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { SsoLoginButtonComponent } from './components/sso-login-button/sso-login-button.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { SocialLoginModule, AuthServiceConfig } from 'angularx-social-login';
import { GoogleLoginProvider, FacebookLoginProvider } from 'angularx-social-login';
import { environment } from '../../../../environments/environment';


// Store FB and Google social configuration
const socialConfig = new AuthServiceConfig([
  {
    id: GoogleLoginProvider.PROVIDER_ID,
    provider: new GoogleLoginProvider(environment.googleClientId)
  },
  {
    id: FacebookLoginProvider.PROVIDER_ID,
    provider: new FacebookLoginProvider(environment.fbClientId)
  }
]);

// Provide social configuration
export function provideSocialConfig() {
  return socialConfig;
}

@NgModule({
  declarations: [LoginComponent, SsoLoginButtonComponent],
  imports: [
    SharedModule,
    ReactiveFormsModule,
    LoginRoutingModule,
    SocialLoginModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ],
  providers: [
    {
      provide: AuthServiceConfig,
      useFactory: provideSocialConfig
    }
  ],
})
export class LoginModule { }
